import { Dispatch, FC, SetStateAction, useRef, useState } from 'react'
import { StackLayout } from '@progress/kendo-react-layout'
import { Window } from '@progress/kendo-react-dialogs'
import { HomeInformation, HomeInformationHandler } from './HomeInformation'
import { Button } from '@progress/kendo-react-buttons'
import { ConfirmDialog, ErrorMessage } from '../../components/parts'
import { PutMessageGateway } from '../../gateway/home/PutMessageGateway'

export interface HomeInformationInputProps {
  // お知らせの編集画面を閉じる
  onCloseEditWindow: () => void
  // 登録修正完了、トップ画面データを再リクエストする
  refetchHomeInformation: () => void
  // エラーメッセージを設定する
  setErrorMessages: Dispatch<SetStateAction<ErrorMessage[]>>
}

export const HomeInformationInput: FC<HomeInformationInputProps> = (props) => {
  /* Dialog info */
  const [confirmDialogShow, setConfirmDialogShow] = useState(false)
  const [title, setTitle] = useState('')
  const [args, setArgs] = useState([''])
  const [dialogMsgId, setDialogMsgId] = useState('I003')
  const [renderCancelButton, setRenderCancelButton] = useState(true)

  const homeInformationRef = useRef<HomeInformationHandler>(null)

  /**
   * 登録ボタン押下
   */
  const handleClickLoginBtn = () => {
    setConfirmDialogShow(true)
    setTitle('登録')

    const updatedMsg = homeInformationRef.current?.getUpdatedMsg()
    if (updatedMsg !== undefined) {
      setArgs(['登録'])
      setDialogMsgId('I007')
    } else {
      // 値の追加/変更がない場合
      setDialogMsgId('E016')
      setRenderCancelButton(false)
    }
  }
  /**
   * 戻るボタン押下
   */
  const handleReturn = () => {
    setConfirmDialogShow(true)
    setTitle('戻る')
    // TODO 差分チェックは行っておらず、必ず破棄の確認が出る状態になっている
    setDialogMsgId('I003')
  }
  /**
   * Dialog 確認ボタン
   */
  const handleConfirmEvent = () => {
    if (title === '登録') {
      const updatedMsg = homeInformationRef.current?.getUpdatedMsg()

      if (updatedMsg !== undefined) {
        PutMessageGateway.loginMsg(updatedMsg)
          .then((res) => {
            if (!res.error) {
              // 登録修正完了
              setTitle('登録完了')
              setDialogMsgId('I004')
              setRenderCancelButton(false)
            } else {
              if (Array.isArray(res.messages) && res.messages.length > 0) {
                const errorMessages = res.messages.map<ErrorMessage>((message) => {
                  return {
                    id: message.id,
                    content: message.message
                  }
                })
                props.setErrorMessages(errorMessages)
              }
            }
          })
          .finally(() => {})
      } else {
        // 値の追加/変更がない場合
        setArgs([''])
        setConfirmDialogShow(false)
        setRenderCancelButton(true)
      }
    }

    if (title === '戻る') {
      setConfirmDialogShow(false)
      setArgs([''])
      setDialogMsgId('I003')
      props.onCloseEditWindow()
      // トップ画面データを再リクエストする
      props.refetchHomeInformation()
    }

    if (title === '登録完了') {
      setArgs([''])
      setConfirmDialogShow(false)
      setRenderCancelButton(true)
      // 全メッセージをrefetch
      homeInformationRef.current?.fetchAllMessages()
    }
  }

  return (
    <>
      <Window
        title={'お知らせの編集'}
        onClose={props.onCloseEditWindow}
        initialWidth={1200}
        initialHeight={280}
        modal
      >
        <HomeInformation ref={homeInformationRef} />

        <StackLayout
          gap={5}
          align={{ horizontal: 'end' }}
          style={{ marginTop: 10 }}
        >
          <Button
            onClick={handleReturn}
            className="pcy-button-short"
          >
            戻る
          </Button>

          <Button
            onClick={handleClickLoginBtn}
            themeColor="primary"
            className="pcy-button-short"
          >
            登録
          </Button>
        </StackLayout>
      </Window>

      {confirmDialogShow && (
        <ConfirmDialog
          open={confirmDialogShow}
          title={title}
          id={dialogMsgId}
          renderCancelButton={renderCancelButton}
          args={args}
          onClickOk={handleConfirmEvent}
          onClickCancel={() => setConfirmDialogShow(false)}
        />
      )}
    </>
  )
}
